import { render, staticRenderFns } from "./Ebook_dtail.vue?vue&type=template&id=04f8b0e8&"
import script from "./Ebook_dtail.vue?vue&type=script&lang=js&"
export * from "./Ebook_dtail.vue?vue&type=script&lang=js&"
import style0 from "./Ebook_dtail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports